import { Navigate } from "react-router-dom";
import pathnames from "../../constants/pathnames";

/**
 * Marketplace root redirects to the add-ons catalog.
 */
const MarketplaceIndex = () => <Navigate to={pathnames.MARKETPLACE_ADDONS} replace />;

export default MarketplaceIndex;
